import * as d3 from 'd3';
import * as topojson from 'topojson-client';
import iconsSvg from '../img/icons.svg';
import clientsSvg from '../img/clients.svg';
import SubscriptionModal from './subscriptionModal.js';

const COUNTRIES_INFO = {
  UKR: {
    name: { en: 'Ukraine', uk: 'Україна' },
    companyCounts: 5,
    description: {
      en: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Vitmark"><svg class="geography__logo__icon-svg" width="126" height="29">
            <use href="${clientsSvg}#vitmark-icon"></use>
            <span class="visually-hidden">Vitmark</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Odrex"><svg class="geography__logo__icon-svg" width="102" height="29">
            <use href="${clientsSvg}#odrex-icon"></use>
            <span class="visually-hidden">Odrex</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Kopiyka"><svg class="geography__logo__icon-svg" width="138" height="29">
            <use href="${clientsSvg}#kopiyka-icon"></use>
            <span class="visually-hidden">Kopiyka</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Shedro"><svg class="geography__logo__icon-svg" width="83" height="32">
            <use href="${clientsSvg}#shedro-icon"></use>
            <span class="visually-hidden">Shedro</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="SBS Group"><svg class="geography__logo__icon-svg" width="72" height="71">
            <use href="${clientsSvg}#logic-up-icon"></use>
            <span class="visually-hidden">SBS Group</span>          
          </svg>
        </span>
      </div>`,
      uk: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Vitmark"><svg class="geography__logo__icon-svg" width="126" height="29">
            <use href="${clientsSvg}#vitmark-icon"></use>
            <span class="visually-hidden">Vitmark</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Odrex"><svg class="geography__logo__icon-svg" width="102" height="29">
            <use href="${clientsSvg}#odrex-icon"></use>
            <span class="visually-hidden">Odrex</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Копійка"><svg class="geography__logo__icon-svg" width="138" height="29">
            <use href="${clientsSvg}#kopiyka-icon"></use>
            <span class="visually-hidden">Копійка</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Щедро"><svg class="geography__logo__icon-svg" width="83" height="32">
            <use href="${clientsSvg}#shedro-icon"></use>
            <span class="visually-hidden">Щедро</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="SBS Group"><svg class="geography__logo__icon-svg" width="72" height="71">
            <use href="${clientsSvg}#logic-up-icon"></use>
            <span class="visually-hidden">SBS Group</span>          
          </svg>
        </span>
      </div>`,
    },
  },
  LTU: {
    name: { en: 'Lithuania', uk: 'Литва' },
    companyCounts: 1,
    description: {
      en: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Prodinvest"><svg class="geography__logo__icon-svg" width="67" height="36">
            <use href="${clientsSvg}#prodinvest-icon"></use>
            <span class="visually-hidden">Prodinvest</span>          
          </svg>
        </span>
      </div>`,
      uk: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Prodinvest"><svg class="geography__logo__icon-svg" width="67" height="36">
            <use href="${clientsSvg}#prodinvest-icon"></use>
            <span class="visually-hidden">Prodinvest</span>          
          </svg>
        </span>
      </div>`,
    },
  },
  DEU: {
    name: { en: 'Germany', uk: 'Німеччина' },
    companyCounts: 2,
    description: {
      en: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Dovgan"><svg class="geography__logo__icon-svg" width="89" height="36">
            <use href="${clientsSvg}#dovgan-icon"></use>
            <span class="visually-hidden">Dovgan</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Monolith"><svg class="geography__logo__icon-svg" width="103" height="29">
            <use href="${clientsSvg}#monolith-icon"></use>
            <span class="visually-hidden">Monolith</span>          
          </svg>
        </span>
      </div>`,
      uk: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Довган"><svg class="geography__logo__icon-svg" width="89" height="36">
            <use href="${clientsSvg}#dovgan-icon"></use>
            <span class="visually-hidden">Довган</span>          
          </svg>
        </span>
        <span class="geography__logo__icon" title="Моноліт"><svg class="geography__logo__icon-svg" width="103" height="29">
            <use href="${clientsSvg}#monolith-icon"></use>
            <span class="visually-hidden">Моноліт</span>          
          </svg>
        </span>
      </div>`,
    },
  },
  BGR: {
    name: { en: 'Bulgaria', uk: 'Болгарія' },
    companyCounts: 1,
    description: {
      en: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Milky"><svg class="geography__logo__icon-svg" width="45" height="43">
            <use href="${clientsSvg}#milky-icon"></use>
            <span class="visually-hidden">Milky</span>          
          </svg>
        </span>
      </div>`,
      uk: `<div class="geography__logo-wrapper">
        <span class="geography__logo__icon" title="Milky"><svg class="geography__logo__icon-svg" width="45" height="43">
            <use href="${clientsSvg}#milky-icon"></use>
            <span class="visually-hidden">Milky</span>          
          </svg>
        </span>
      </div>`,
    },
  },
};

const EUROPE_COUNTRY_NAMES = {
  ALB: { en: 'Albania', uk: 'Албанія' },
  AUT: { en: 'Austria', uk: 'Австрія' },
  BEL: { en: 'Belgium', uk: 'Бельгія' },
  BGR: { en: 'Bulgaria', uk: 'Болгарія' },
  BIH: { en: 'Bosnia and Herzegovina', uk: 'Боснія і Герцеговина' },
  CHE: { en: 'Switzerland', uk: 'Швейцарія' },
  CYP: { en: 'Cyprus', uk: 'Кіпр' },
  CZE: { en: 'Czechia', uk: 'Чехія' },
  DEU: { en: 'Germany', uk: 'Німеччина' },
  DNK: { en: 'Denmark', uk: 'Данія' },
  EST: { en: 'Estonia', uk: 'Естонія' },
  ESP: { en: 'Spain', uk: 'Іспанія' },
  FIN: { en: 'Finland', uk: 'Фінляндія' },
  FRA: { en: 'France', uk: 'Париж' },
  GBR: { en: 'United Kingdom', uk: 'Велика Британія' },
  GRC: { en: 'Greece', uk: 'Греція' },
  HRV: { en: 'Croatia', uk: 'Хорватія' },
  HUN: { en: 'Hungary', uk: 'Угорщина' },
  IRL: { en: 'Ireland', uk: 'Ірландія' },
  ISL: { en: 'Iceland', uk: 'Ісландія' },
  ITA: { en: 'Italy', uk: 'Італія' },
  LTU: { en: 'Lithuania', uk: 'Литва' },
  LUX: { en: 'Luxembourg', uk: 'Люксембург' },
  LVA: { en: 'Latvia', uk: 'Латвія' },
  MDA: { en: 'Moldova', uk: 'Молдова' },
  MKD: { en: 'North Macedonia', uk: 'Північна Македонія' },
  MLT: { en: 'Malta', uk: 'Мальта' },
  MNE: { en: 'Montenegro', uk: 'Чорногорія' },
  NLD: { en: 'Netherlands', uk: 'Нідерланди' },
  NOR: { en: 'Norway', uk: 'Норвегія' },
  POL: { en: 'Poland', uk: 'Польща' },
  PRT: { en: 'Portugal', uk: 'Португалія' },
  ROU: { en: 'Romania', uk: 'Румунія' },
  SRB: { en: 'Serbia', uk: 'Сербія' },
  SVK: { en: 'Slovakia', uk: 'Словаччина' },
  SVN: { en: 'Slovenia', uk: 'Словенія' },
  SWE: { en: 'Sweden', uk: 'Швеція' },
  UKR: { en: 'Ukraine', uk: 'Україна' },
  TUR: { en: 'Turkey', uk: 'Туреччина' },
};

const EUROPE_ISO = Object.keys(EUROPE_COUNTRY_NAMES);
const DEFAULT_EUROPE_FILL = 'rgba(89, 151, 236, 0.50)';
const ACTIVE_FILL = '#2563EB';
const ACTIVE_STROKE = '#FFFFFF';
const IS_TOUCH = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
const MAP_RESPONSIVE_CONFIG = [
  { min: 0, max: 767, center: [15, 53], scaleFactor: 0.985 },
  { min: 768, max: 1199, center: [18, 52], scaleFactor: 1 },
  { min: 1200, max: Infinity, center: [27, 55], scaleFactor: 0.975 },
];
function getResponsiveMapSettings(width = window.innerWidth) {
  return MAP_RESPONSIVE_CONFIG.find(c => width >= c.min && width <= c.max) || MAP_RESPONSIVE_CONFIG[0];
}

// Crimea SVG viewBox and path (single source of truth)
const CRIMEA_SVG_VIEWBOX = { width: 98, height: 64 };
const CRIMEA_SVG_PATH =
  'M26.6304 5.10547L28.0918 3.37329L28.1758 0.860352L31.7017 1.27979L36.9434 4.74756L39.3496 5.34741L41.6689 4.9281L44.7632 6.30237L47.0825 9.58313L48.8018 9.22473H52.7563L55.2471 12.1442L55.418 15.5958L58.9438 17.7346L60.2305 17.557L60.7466 18.6829L66.4175 27.3281L69.082 30.5151L71.147 31.8121L73.5532 31.9893L78.1079 29.2766L80.0825 28.8635L84.3794 29.9249L85.9277 28.0958L88.1626 27.1506L90.9985 27.0312L94.2632 27.7991L97.7852 29.1572L96.3271 32.2247L94.8662 34.6378L94.2632 37.2861L93.4888 40.2798L89.5366 41.6282L85.4111 41.4541L80.9434 42.3314L79.395 41.1603L78.3662 40.1023L76.3887 39.0475L73.811 38.4604L71.4888 39.1635L68.7402 43.2119L63.9272 45.9636L62.2949 49.1185L57.4819 48.4183L53.4434 49.0023L47.5112 51.8604L43.0435 58.0345L38.147 61.8668L34.1919 63.0861L30.498 62.6797L28.0918 61.5186L23.1919 57.5121L23.5371 56.0573L24.2241 55.2992L25.082 53.2603L27.0596 45.6119L26.8013 43.0925L25.6855 39.2218L21.8179 36.1669L18.7241 36.6959L16.9175 35.9314L10.4722 30.6926L7.03711 30.3378L3.16943 31.399L1.79199 30.6313L0.675781 28.8022L8.32373 22.3604L15.8887 17.0217L19.1533 16.4862L23.6211 13.9894L28.3496 10.2411L27.6597 7.31531L26.6304 5.10547Z';

// Capital coordinates (single source of truth)
const CAPITALS = {
  ALB: { lon: 19.8187, lat: 41.3275 },
  AUT: { lon: 16.3738, lat: 48.2082 },
  BEL: { lon: 4.3517, lat: 50.8503 },
  BGR: { lon: 23.3219, lat: 42.6977 },
  BIH: { lon: 18.4131, lat: 43.8563 },
  CHE: { lon: 7.4474, lat: 46.948 },
  CYP: { lon: 33.3823, lat: 35.1856 },
  CZE: { lon: 14.4378, lat: 50.0755 },
  DEU: { lon: 13.405, lat: 52.52 },
  DNK: { lon: 12.5683, lat: 55.6761 },
  EST: { lon: 24.7536, lat: 59.437 },
  ESP: { lon: -3.7038, lat: 40.4168 },
  FIN: { lon: 24.9384, lat: 60.1699 },
  FRA: { lon: 2.3522, lat: 48.8566 },
  GBR: { lon: -0.1276, lat: 51.5074 },
  GRC: { lon: 23.7275, lat: 37.9838 },
  HRV: { lon: 15.9819, lat: 45.815 },
  HUN: { lon: 19.0402, lat: 47.4979 },
  IRL: { lon: -6.2603, lat: 53.3498 },
  ISL: { lon: -21.8277, lat: 64.1265 },
  ITA: { lon: 12.4964, lat: 41.9028 },
  LTU: { lon: 25.2797, lat: 54.6872 },
  LUX: { lon: 6.1319, lat: 49.6116 },
  LVA: { lon: 24.1052, lat: 56.9496 },
  MDA: { lon: 28.8353, lat: 47.0105 },
  MKD: { lon: 21.4316, lat: 41.9981 },
  MLT: { lon: 14.5146, lat: 35.8989 },
  MNE: { lon: 19.261, lat: 42.4304 },
  NLD: { lon: 4.9041, lat: 52.3676 },
  NOR: { lon: 10.7522, lat: 59.9139 },
  POL: { lon: 21.0122, lat: 52.2297 },
  PRT: { lon: -9.1393, lat: 38.7223 },
  ROU: { lon: 26.1025, lat: 44.4268 },
  SRB: { lon: 20.4489, lat: 44.7866 },
  SVK: { lon: 17.1077, lat: 48.1486 },
  SVN: { lon: 14.5058, lat: 46.0569 },
  SWE: { lon: 18.0686, lat: 59.3293 },
  UKR: { lon: 30.5234, lat: 50.4501 },
  TUR: { lon: 32.8597, lat: 39.9334 },
};

export function initGeographyMapLazy() {
  const target = document.getElementById('geography');
  if (!target) return;
  let hasLoaded = false;
  let selectedCountry = null;
  let lastSelectedPath = null;
  let activeMarkerEl = null;
  let svg = null;
  let projection = null;
  let path = null;
  let countries = null;
  let tooltip = null;

  let worldDataCache = null;
  let lastContainerWidth = null;
  let resizeTimer = null;
  let resizeObs = null;
  let currentMapUrl = null;

  function buildTooltip() {
    const el = document.createElement('div');
    el.className = 'geography-tooltip';
    document.querySelector('#geographyMap')?.appendChild(el);
    return el;
  }

  // Position tooltip near the mouse pointer within the map container
  function positionTooltip(event) {
    if (!tooltip) return;
    const container = document.getElementById('geographyMap');
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const offsetX = 12;
    const offsetY = 12;
    tooltip.style.left = `${x + offsetX}px`;
    tooltip.style.top = `${y + offsetY}px`;
  }

  function getCurrentLang() {
    return document.documentElement.lang === 'uk' ? 'uk' : 'en';
  }

  function getCountryName(d) {
    if (!d) return '';
    const lang = getCurrentLang();
    if (COUNTRIES_INFO[d.id] && COUNTRIES_INFO[d.id].name && COUNTRIES_INFO[d.id].name[lang]) {
      return COUNTRIES_INFO[d.id].name[lang];
    }
    if (EUROPE_COUNTRY_NAMES && EUROPE_COUNTRY_NAMES[d.id] && EUROPE_COUNTRY_NAMES[d.id][lang]) {
      return EUROPE_COUNTRY_NAMES[d.id][lang];
    }
    return (d.properties && d.properties.name) || d.id || '';
  }

  function resetInfoPanel() {
    const nameEl = document.querySelector('.geography__country-name');
    const descEl = document.querySelector('.geography__country-description');
    if (!nameEl || !descEl) return;
    nameEl.textContent = nameEl.dataset.defaultTitle || 'Selected Country';
    const t = descEl.dataset.defaultText || '';
    descEl.innerHTML = t
      .split('\n')
      .map(p => `<p>${p}</p>`)
      .join('');
  }

  function togglePanels(hasSelection) {
    const selectedBlock = document.querySelector('.geography__selected');
    const defaultBlock = document.querySelector('.geography__info-default');
    if (!selectedBlock || !defaultBlock) return;
    if (hasSelection) {
      selectedBlock.style.display = '';
      defaultBlock.style.display = 'none';
      selectedBlock.setAttribute('aria-hidden', 'false');
      defaultBlock.setAttribute('aria-hidden', 'true');
    } else {
      selectedBlock.style.display = 'none';
      defaultBlock.style.display = '';
      selectedBlock.setAttribute('aria-hidden', 'true');
      defaultBlock.setAttribute('aria-hidden', 'false');
    }
  }

  function updateInfoPanel(iso) {
    const lang = getCurrentLang();
    const data = COUNTRIES_INFO[iso];
    const nameEl = document.querySelector('.geography__country-name');
    const descEl = document.querySelector('.geography__country-description');
    if (!nameEl || !descEl) return;
    if (!iso) {
      resetInfoPanel();
      togglePanels(false);
      return;
    }
    let fullName;
    let descHtml = '';
    if (data && data.name && data.name[lang]) {
      fullName = data.name[lang];
      descHtml = data.description && data.description[lang]
        ? data.description[lang]
        : '';
    } else {
      fullName = EUROPE_COUNTRY_NAMES && EUROPE_COUNTRY_NAMES[iso] && EUROPE_COUNTRY_NAMES[iso][lang] ? EUROPE_COUNTRY_NAMES[iso][lang] : iso;
    }
    nameEl.innerHTML =
      fullName +
      `<span class="geography__cta-info__icon"><svg class="geography__cta-info__icon-svg" width="30" height="36">
          <use href="${iconsSvg}#location-icon"></use>
          <span class="visually-hidden">Location Icon</span>          
        </svg></span>`;
    
    const textEnding = lang === 'en' ? `
      <div class="geography__desc-ending">
        <p class="geography__note def-text">Your logistics — our mission.<br>Your success — our goal.</p>
        <button class="geography__more-btn location">Interested in becoming a trusted partner?</button>
      </div>
      ` : `
      <div class="geography__desc-ending">
        <p class="geography__note def-text">Ваша логістика — наша справа.<br>Ваш успіх — наша мета.</p>
        <button class="geography__more-btn location">Хочете стати частиною надійної логістичної мережі?</button>
      </div>
      `;
    descEl.innerHTML = descHtml + (iso !== 'UKR' ? textEnding : '');
    togglePanels(true);

    const partnerBtn = descEl.querySelector('.geography__more-btn.location');
    if (partnerBtn && iso !== 'UKR') {
        partnerBtn?.addEventListener('click', () => {
        const modal = new SubscriptionModal({ type: 3 });
        modal.open();
      });
    }
  }

  // Reset styles for all base country paths (no overlays)
  function resetBaseStyles() {
    if (!svg) return;
    const subunitsG = svg.select('g.datamaps-subunits');
    subunitsG
      .selectAll('.datamaps-subunit')
      .classed('selected-country', false)
      .classed('active-country', false)
      .classed('hovered', false)
      .attr('fill', d => (d.id === 'UKR' ? '#7AACF0' : DEFAULT_EUROPE_FILL))
      .attr('stroke', '#FFFFFF')
      .attr('stroke-width', 1);
  }

  // Programmatic select/deselect with UI updates
  function setSelectedCountry(iso) {
    if (!svg) return;
    if (!iso || selectedCountry === iso) {
      selectedCountry = null;
      resetBaseStyles();
      highlightSelected(null);
      resetInfoPanel();
      togglePanels(false);
      return;
    }
    selectedCountry = iso;
    updateInfoPanel(iso);
    resetBaseStyles();
    highlightSelected(iso);
  }

  // Always render company count labels after country selection/highlight
  function renderCompanyCountLabels() {
    // Remove existing labels if any
    svg.selectAll('g.geography__company-count-label').remove();
    svg.select('g.datamaps-subunits')
      .selectAll('g.geography__company-count-label')
      .data(countries.filter(d => d.geometry && COUNTRIES_INFO[d.id] && typeof COUNTRIES_INFO[d.id].companyCounts === 'number'))
      .enter()
      .append('g')
      .attr('class', 'geography__company-count-label')
      .attr('transform', d => {
        const c = path.centroid(d);
        return `translate(${c[0]},${c[1]})`;
      })
      .attr('pointer-events', 'none')
      .each(function(d) {
        const group = d3.select(this);
        group.append('circle')
          .attr('r', 8)
          .attr('fill', 'rgba(255,255,255,0.15)')
          .attr('stroke', '#FFFFFF')
          .attr('stroke-opacity', 0.5)
          .attr('stroke-width', 1);
        group.append('text')
          .attr('text-anchor', 'middle')
          .attr('alignment-baseline', 'central')
          .attr('font-size', '14px')
          .attr('font-weight', 'bold')
          .attr('fill', '#FFFFFF')
          .attr('pointer-events', 'none')
          .text(COUNTRIES_INFO[d.id].companyCounts);
      });
  }

  function highlightSelected(iso) {
    if (!svg) return;
    if (lastSelectedPath) {
      const sel = d3.select(lastSelectedPath);
      const lastD = sel.datum();
      const baseFill = lastD && lastD.id === 'UKR' ? '#7AACF0' : DEFAULT_EUROPE_FILL;
      sel
        .classed('selected-country', false)
        .classed('active-country', false)
        .classed('hovered', false)
        .attr('fill', baseFill)
        .attr('stroke', '#FFFFFF')
        .attr('stroke-width', 1);
      lastSelectedPath = null;
    }
    if (!iso) {
      if (activeMarkerEl) {
        activeMarkerEl.remove();
        activeMarkerEl = null;
      }
      d3.select('.crimea-overlay').attr('fill', '#7AACF0').attr('stroke', 'none').attr('stroke-width', null);
      return;
    }
    const target = svg.select(`g.datamaps-subunits path[data-id='${iso}']`);
    if (!target.empty()) {
      target.classed('selected-country', true).classed('active-country', true).attr('fill', ACTIVE_FILL).attr('stroke', ACTIVE_STROKE).attr('stroke-width', 1);
      lastSelectedPath = target.node();

      // Ensure Crimea overlay mirrors Ukraine's active state on selection (important for touch devices)
      const crimeaOverlay = d3.select('.crimea-overlay');
      if (!crimeaOverlay.empty()) {
        if (iso === 'UKR') {
          crimeaOverlay.attr('fill', ACTIVE_FILL);
        } else {
          crimeaOverlay.attr('fill', '#7AACF0').attr('stroke', 'none').attr('stroke-width', null);
        }
      }

      const d = target.datum();
      let markerPos = null;
      const cap = CAPITALS[iso];
      if (cap && projection) markerPos = projection([cap.lon, cap.lat]);
      if (!markerPos) markerPos = path.centroid(d);
      if (!activeMarkerEl) {
        activeMarkerEl = svg.append('g').attr('class', 'geography__marker');
        const icon = activeMarkerEl.append('svg').attr('class', 'marker-icon').attr('width', 30).attr('height', 36).attr('viewBox', '0 0 33 38');
        icon.append('use').attr('href', `${iconsSvg}#location-icon`).attr('xlink:href', `${iconsSvg}#location-icon`);
      }
      activeMarkerEl.attr('transform', `translate(${markerPos[0] - 15},${markerPos[1] - 36})`);

      // Bring selected path to front
      const node = target.node();
      const parentGroup = node && node.parentNode;
      if (parentGroup && parentGroup.appendChild) parentGroup.appendChild(node);
    } else {
      if (activeMarkerEl) {
        activeMarkerEl.remove();
        activeMarkerEl = null;
      }
      d3.select('.crimea-overlay').attr('fill', '#7AACF0').attr('stroke', 'none').attr('stroke-width', null);
    }
    renderCompanyCountLabels();
  }

  // Map variant by container width
  function getDesiredMapUrl() {
    const container = document.getElementById('geographyMap');
    const w = container ? container.offsetWidth : window.innerWidth;
    return w <= 767 ? '/europe.mobile.json' : '/europe.desktop.json';
  }

  // Safe load TopoJSON with fallback
  async function loadAndRenderMap(url, { preserveSelection = false } = {}) {
    async function tryLoad(u) {
      const res = await fetch(u, { cache: 'no-store' });
      if (!res.ok) throw new Error(`HTTP ${res.status} for ${u}`);
      const data = await res.json();
      if (!(data && data.objects && data.objects.countries)) throw new Error('Invalid TopoJSON structure');
      return data;
    }
    try {
      const data = await tryLoad(url);
      worldDataCache = data;
      currentMapUrl = url;
      renderMap(worldDataCache);
      if (preserveSelection && selectedCountry) {
        updateInfoPanel(selectedCountry);
        highlightSelected(selectedCountry);
      } else if (!preserveSelection) {
        resetInfoPanel();
        togglePanels(false);
      }
    } catch (e) {
      if (url !== '/europe.json') {
        try {
          const res = await fetch('/europe.json', { cache: 'no-store' });
          if (!res.ok) throw new Error(`HTTP ${res.status} for /europe.json`);
          const jd = await res.json();
          if (!(jd && jd.objects && jd.objects.countries)) throw new Error('Invalid TopoJSON structure');
          worldDataCache = jd;
          currentMapUrl = '/europe.json';
          renderMap(worldDataCache);
          if (preserveSelection && selectedCountry) {
            updateInfoPanel(selectedCountry);
            highlightSelected(selectedCountry);
          }
        } catch (fallbackErr) {
          console.error('Failed to load map (variant and fallback):', e, fallbackErr);
        }
      } else {
        console.error('Failed to load /europe.json:', e);
      }
    }
  }

  const ISO_NUM_TO_ALPHA3 = {
    '008': 'ALB',
    '040': 'AUT',
    '056': 'BEL',
    '070': 'BIH',
    100: 'BGR',
    112: 'BLR',
    191: 'HRV',
    196: 'CYP',
    203: 'CZE',
    208: 'DNK',
    233: 'EST',
    246: 'FIN',
    250: 'FRA',
    276: 'DEU',
    300: 'GRC',
    348: 'HUN',
    352: 'ISL',
    372: 'IRL',
    380: 'ITA',
    428: 'LVA',
    440: 'LTU',
    442: 'LUX',
    470: 'MLT',
    499: 'MNE',
    528: 'NLD',
    578: 'NOR',
    616: 'POL',
    620: 'PRT',
    642: 'ROU',
    688: 'SRB',
    703: 'SVK',
    705: 'SVN',
    724: 'ESP',
    752: 'SWE',
    756: 'CHE',
    792: 'TUR',
    804: 'UKR',
    807: 'MKD',
    826: 'GBR',
    498: 'MDA',
  };

  function renderMap(worldData) {
    if (!worldData || !worldData.objects || !worldData.objects.countries) {
      console.error('worldData.objects.countries отсутствує або некоректен', worldData);
      return;
    }
    const countriesData = topojson.feature(worldData, worldData.objects.countries);
    if (!countriesData || !countriesData.features) {
      console.error('countriesData.features отсутствує або некоректен', countriesData);
      return;
    }

    const cfg = getResponsiveMapSettings();
    const container = document.getElementById('geographyMap');
    container.innerHTML = '';
    const width = container.offsetWidth;
    const height = container.offsetHeight || width;

    projection = d3
      .geoMercator()
      .center(cfg.center)
      .scale(Math.min(width, height) * cfg.scaleFactor)
      .translate([width / 2, height / 2]);
    path = d3.geoPath().projection(projection);

    svg = d3
      .select(container)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink');

    tooltip = buildTooltip();

    let atlasAlpha3 = countriesData.features
      .map(f => {
        const alpha3 = ISO_NUM_TO_ALPHA3[f.id];
        return alpha3 ? { ...f, id: alpha3 } : null;
      })
      .filter(f => f);

    const ukraineFeature = atlasAlpha3.find(f => f.id === 'UKR');

    function ukraineHasCrimea() {
      if (!ukraineFeature || !ukraineFeature.geometry) return false;
      const bbox = [32.5, 44.4, 36.7, 46.3];
      const multi = ukraineFeature.geometry.type === 'MultiPolygon' ? ukraineFeature.geometry.coordinates : [ukraineFeature.geometry.coordinates];
      return multi.some(poly => {
        const outer = Array.isArray(poly[0]) ? poly[0] : poly;
        return outer.some(([lon, lat]) => lon >= bbox[0] && lon <= bbox[2] && lat >= bbox[1] && lat <= bbox[3]);
      });
    }

    function addCrimeaFromSVGToUkraine() {
      try {
        if (!ukraineFeature || !ukraineFeature.geometry || ukraineHasCrimea()) return;
        const tmp = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        tmp.setAttribute('d', CRIMEA_SVG_PATH);
        tmp.setAttribute('fill', 'none');
        tmp.setAttribute('stroke', 'none');
        svg.node().appendChild(tmp);
        const total = tmp.getTotalLength();
        const samples = 1; // keep minimal for perf
        const pts = [];
        for (let i = 0; i <= samples; i++) {
          const p = tmp.getPointAtLength((i / samples) * total);
          pts.push([p.x, p.y]);
        }
        tmp.remove();
        const bbox = { west: 32.5, south: 44.4, east: 36.7, north: 46.3 };
        const pNW = projection([bbox.west, bbox.north]);
        const pSE = projection([bbox.east, bbox.south]);
        if (!pNW || !pSE) return;
        const minX = Math.min(pNW[0], pSE[0]);
        const maxX = Math.max(pNW[0], pSE[0]);
        const minY = Math.min(pNW[1], pSE[1]);
        const maxY = Math.max(pNW[1], pSE[1]);
        const targetW = maxX - minX;
        const targetH = maxY - minY;
        const scale = Math.min(targetW / CRIMEA_SVG_VIEWBOX.width, targetH / CRIMEA_SVG_VIEWBOX.height);
        const tx = minX + (targetW - CRIMEA_SVG_VIEWBOX.width * scale) / 2;
        const ty = minY + (targetH - CRIMEA_SVG_VIEWBOX.height * scale) / 2;
        const ring = pts.map(([x, y]) => {
          const px = tx + x * scale;
          const py = ty + y * scale;
          const lonlat = projection.invert([px, py]);
          return [lonlat[0], lonlat[1]];
        });
        if (ring.length) {
          const f = ring[0],
            l = ring[ring.length - 1];
          if (Math.abs(f[0] - l[0]) > 1e-6 || Math.abs(f[1] - l[1]) > 1e-6) ring.push([...f]);
        }
        const crimeaPoly = [ring];
        if (ukraineFeature.geometry.type === 'MultiPolygon') {
          ukraineFeature.geometry.coordinates.push(crimeaPoly);
        } else if (ukraineFeature.geometry.type === 'Polygon') {
          ukraineFeature.geometry = {
            type: 'MultiPolygon',
            coordinates: [ukraineFeature.geometry.coordinates, crimeaPoly],
          };
        }
      } catch (e) {
        console.warn('Failed to derive Crimea polygon from SVG path:', e);
      }
    }

    if (ukraineFeature && ukraineFeature.geometry && !ukraineHasCrimea()) {
      addCrimeaFromSVGToUkraine();
      if (!ukraineHasCrimea()) {
        const manualCrimeaRing = [
          [32.5, 45.4],
          [33.2, 45.9],
          [34.0, 46.1],
          [36.6, 45.6],
          [36.6, 45.3],
          [36.0, 45.05],
          [34.9, 44.5],
          [33.7, 44.45],
          [32.5, 45.0],
          [32.5, 45.4],
        ];
        const first = manualCrimeaRing[0];
        const last = manualCrimeaRing[manualCrimeaRing.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) manualCrimeaRing.push([...first]);
        const manualCrimeaPoly = [manualCrimeaRing];
        if (ukraineFeature.geometry.type === 'MultiPolygon') {
          ukraineFeature.geometry.coordinates.push(manualCrimeaPoly);
        } else if (ukraineFeature.geometry.type === 'Polygon') {
          ukraineFeature.geometry = {
            type: 'MultiPolygon',
            coordinates: [ukraineFeature.geometry.coordinates, manualCrimeaPoly],
          };
        }
      }
    }

    atlasAlpha3 = atlasAlpha3.filter(f => f.id !== 'RUS');

    const allEuropeCountries = EUROPE_ISO.map(code => {
      const found = atlasAlpha3.find(f => f.id === code);
      if (found) return found;
      return { id: code, type: 'Feature', properties: { name: EUROPE_COUNTRY_NAMES[code].en }, geometry: null };
    });
    countries = allEuropeCountries;

    const defs = svg.append('defs');
    const europeClip = defs.append('clipPath').attr('id', 'europe-clip').attr('clipPathUnits', 'userSpaceOnUse');

    europeClip
      .selectAll('path')
      .data(countries.filter(d => d && d.geometry))
      .enter()
      .append('path')
      .attr('d', path);

    const subunitsG = svg.append('g').attr('class', 'datamaps-subunits').attr('clip-path', 'url(#europe-clip)');

    subunitsG
      .selectAll('path')
      .data(countries.filter(d => d.geometry))
      .enter()
      .append('path')
      .attr('class', 'datamaps-subunit')
      .attr('data-id', d => d.id)
      .attr('d', path)
      .attr('fill', d => (d.id === 'UKR' ? '#7AACF0' : DEFAULT_EUROPE_FILL))
      .attr('stroke', '#FFFFFF')
      .attr('stroke-width', 1)
      .style('cursor', 'pointer')
      .on('click', function (event, d) {
        if (IS_TOUCH) return; // avoid double toggle on touch; handled by pointerdown
        setSelectedCountry(selectedCountry === d.id ? null : d.id);
      })
      .on('pointerdown', function (event, d) {
        if (!IS_TOUCH) return;
        event.preventDefault();
        setSelectedCountry(selectedCountry === d.id ? null : d.id);
      })
      .on('mouseover', function (event, d) {
        if (IS_TOUCH) return;
        if (this === lastSelectedPath) return;
        d3.select(this).classed('hovered', true).attr('fill', '#2563EB');
        if (d.id === 'UKR') {
          const crimeaOverlay = d3.select('.crimea-overlay');
          if (!crimeaOverlay.empty()) crimeaOverlay.attr('fill', '#2563EB');
        }
        if (tooltip) {
          tooltip.textContent = getCountryName(d);
          tooltip.classList.add('is-visible');
          positionTooltip(event);
        }
      })
      .on('mousemove', function (event) {
        if (IS_TOUCH) return;
        positionTooltip(event);
      })
      .on('mouseout', function (event, d) {
        if (IS_TOUCH) return;
        if (this === lastSelectedPath) {
          if (tooltip) tooltip.classList.remove('is-visible');
          return;
        }
        d3.select(this)
          .classed('hovered', false)
          .attr('fill', d.id === 'UKR' ? '#7AACF0' : DEFAULT_EUROPE_FILL);
        if (d.id === 'UKR' && selectedCountry !== 'UKR') {
          const crimeaOverlay = d3.select('.crimea-overlay');
          if (!crimeaOverlay.empty()) {
            crimeaOverlay.attr('fill', '#7AACF0').attr('stroke', 'none').attr('stroke-width', null);
          }
        }
        if (tooltip) tooltip.classList.remove('is-visible');
      });

    renderCompanyCountLabels();

    subunitsG
      .selectAll('g.geography__company-count-label')
      .data(countries.filter(d => d.geometry && COUNTRIES_INFO[d.id] && typeof COUNTRIES_INFO[d.id].companyCounts === 'number'))
      .enter()
      .append('g')
      .attr('class', 'geography__company-count-label')
      .attr('transform', d => {
        const c = path.centroid(d);
        return `translate(${c[0]},${c[1]})`;
      })
      .attr('pointer-events', 'none')
      .each(function(d) {
        const group = d3.select(this);
        group.append('circle')
          .attr('r', 8)
          .attr('fill', 'rgba(255,255,255,0.15)')
          .attr('stroke', '#FFFFFF')
          .attr('stroke-opacity', 0.5)
          .attr('stroke-width', 1);
        group.append('text')
          .attr('text-anchor', 'middle')
          .attr('alignment-baseline', 'central')
          .attr('font-size', '14px')
          .attr('font-weight', 'bold')
          .attr('fill', '#FFFFFF')
          .attr('pointer-events', 'none')
          .text(COUNTRIES_INFO[d.id].companyCounts);
      });

    const overlaysG = svg.append('g').attr('class', 'map-overlays');

    (function addCrimeaOverlay() {
      const bbox = { west: 32.5, south: 44.4, east: 36.7, north: 46.3 };
      const pNW = projection([bbox.west, bbox.north]);
      const pSE = projection([bbox.east, bbox.south]);
      if (!pNW || !pSE) return;
      const minX = Math.min(pNW[0], pSE[0]);
      const maxX = Math.max(pNW[0], pSE[0]);
      const minY = Math.min(pNW[1], pSE[1]);
      const maxY = Math.max(pNW[1], pSE[1]);
      const targetW = maxX - minX;
      const targetH = maxY - minY;
      const scale = Math.min(targetW / CRIMEA_SVG_VIEWBOX.width, targetH / CRIMEA_SVG_VIEWBOX.height);
      const tx = minX + (targetW - CRIMEA_SVG_VIEWBOX.width * scale) / 2;
      const ty = minY + (targetH - CRIMEA_SVG_VIEWBOX.height * scale) / 2;

      overlaysG
        .append('path')
        .attr('class', 'datamaps-subunit crimea-overlay')
        .attr('data-id', 'UKR')
        .attr('d', CRIMEA_SVG_PATH)
        .attr('transform', `translate(${tx},${ty}) scale(${scale})`)
        .attr('fill', '#7AACF0')
        .attr('stroke', 'none')
        .style('pointer-events', 'all')
        .style('cursor', 'pointer')
        .on('click', function (event) {
          if (IS_TOUCH) return; // avoid double toggle on touch; handled by pointerdown
          setSelectedCountry(selectedCountry === 'UKR' ? null : 'UKR');
        })
        .on('pointerdown', function (event) {
          if (!IS_TOUCH) return;
          event.preventDefault();
          setSelectedCountry(selectedCountry === 'UKR' ? null : 'UKR');
        })
        .on('mouseover', function (event) {
          if (IS_TOUCH) return;
          if (tooltip) {
            tooltip.textContent = getCountryName({ id: 'UKR' });
            tooltip.classList.add('is-visible');
            positionTooltip(event);
          }
          const ukrPath = svg.select("g.datamaps-subunits path[data-id='UKR']");
          if (!ukrPath.empty() && ukrPath.node() !== lastSelectedPath) {
            ukrPath.classed('hovered', true).attr('fill', '#2563EB');
          }
          d3.select(this).attr('fill', '#2563EB');
        })
        .on('mousemove', function (event) {
          if (IS_TOUCH) return;
          positionTooltip(event);
        })
        .on('mouseout', function () {
          if (IS_TOUCH) return;
          if (selectedCountry === 'UKR') {
            d3.select(this).attr('fill', ACTIVE_FILL).attr('stroke', '#FFFFFF').attr('stroke-width', 1);
          } else {
            d3.select(this).attr('fill', '#7AACF0').attr('stroke', 'none').attr('stroke-width', null);
          }
          const ukrPath = svg.select("g.datamaps-subunits path[data-id='UKR']");
          if (!ukrPath.empty() && ukrPath.node() !== lastSelectedPath) {
            ukrPath.classed('hovered', false).attr('fill', '#7AACF0').attr('stroke', '#FFFFFF').attr('stroke-width', 1);
          }
          if (tooltip) tooltip.classList.remove('is-visible');
        });
    })();

    resetInfoPanel();
    togglePanels(false);
  }

  // Deduplicated: thin wrapper if needed elsewhere
  function renderMapStepwise(worldData) {
    renderMap(worldData);
  }

  function rerenderMapPreservingSelection() {
    if (!worldDataCache) return;
    renderMap(worldDataCache);
    if (selectedCountry) {
      updateInfoPanel(selectedCountry);
      highlightSelected(selectedCountry);
    }
  }

  function scheduleResizeRerender(force = false) {
    const container = document.getElementById('geographyMap');
    if (!container) return;
    const w = container.offsetWidth;
    const desiredUrl = getDesiredMapUrl();
    if (!force && w === lastContainerWidth && desiredUrl === currentMapUrl) return;
    lastContainerWidth = w;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (desiredUrl && desiredUrl !== currentMapUrl) {
        loadAndRenderMap(desiredUrl, { preserveSelection: true });
      } else if (worldDataCache) {
        rerenderMapPreservingSelection();
      }
    }, 150);
  }

  // Hook up back button to reset to default state
  const backBtn = document.querySelector('.geography__back-btn');
  if (backBtn) {
    const resetToDefault = event => {
      event.preventDefault();
      if (svg) {
        setSelectedCountry(null);
      } else {
        // Map not initialized yet, just reset panels/text state
        selectedCountry = null;
        resetInfoPanel();
        togglePanels(false);
      }
    };
    backBtn.addEventListener('click', resetToDefault);
    backBtn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        resetToDefault(e);
      }
    });
  }

  // Lazy init
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasLoaded) {
          hasLoaded = true;
          const container = document.getElementById('geographyMap');
          const w = container ? container.offsetWidth : window.innerWidth;
          const initialUrl = getDesiredMapUrl();
          loadAndRenderMap(initialUrl)
            .then(() => {
              lastContainerWidth = w;
              if ('ResizeObserver' in window && container && !resizeObs) {
                resizeObs = new ResizeObserver(() => scheduleResizeRerender());
                resizeObs.observe(container);
              }
              window.addEventListener('resize', scheduleResizeRerender);
            })
            .catch(err => {
              console.error('Map load/render failed:', err);
            });
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '100px' }
  );

  observer.observe(target);
}
